import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "container",
  style: {"align-content":"flex-start"}
}

import {reactive, UnwrapRef} from "vue";
import {finishTask} from "@/api/home";
import {useRoute} from "vue-router";
import {message} from "ant-design-vue";
import router from "@/router";

interface Item {
  amount: number
}


export default /*#__PURE__*/_defineComponent({
  __name: 't110',
  setup(__props) {


const route = useRoute();

let item: UnwrapRef<Item> = reactive({
  amount: 0.00
});

const finishTask109 = () => {
  let processDefinitionId = route.query.processDefinitionId;
  let processInstanceId = route.query.processInstanceId;
  let processDefinitionKey = route.query.processDefinitionKey;
  let runTimeTaskId = route.query.runTimeTaskId;
  let taskCode = route.query.taskCode
  let parameters = {
    processDefinitionId: processDefinitionId,
    processInstanceId: processInstanceId,
    processDefinitionKey: processDefinitionKey,
    runTimeTaskId: runTimeTaskId,
    taskCode: taskCode,
    params: {
      saleOrderId: route.query.saleOrderId,
      clinicId: route.query.clinicId,
      amount: item.amount
    }
  };

  finishTask(parameters).then(() => {
    message.success("操作成功");
    router.push({
      path: "/home",
    });
  });
}

return (_ctx: any,_cache: any) => {
  const _component_a_input_number = _resolveComponent("a-input-number")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_form, {
      model: _unref(item),
      autoComplete: "off",
      ref: "refProcessForm"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form_item, {
          label: "金额",
          name: "name"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input_number, {
              value: _unref(item).amount,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_unref(item).amount) = $event)),
              style: {"width":"200px"},
              defaultValue: 0,
              precision: 2,
              min: 0,
              step: 0.01,
              "string-mode": ""
            }, null, 8, ["value", "step"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, null, {
          default: _withCtx(() => [
            (_unref(item).amount > 0)
              ? (_openBlock(), _createBlock(_component_a_button, {
                  key: 0,
                  onClick: finishTask109
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("提交")
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model"])
  ]))
}
}

})